/**
 * Definition for bundle. See source for details.
 *
 * @class Oskari.file-upload.Bundle
 */
Oskari.clazz.define('Oskari.file-upload.Bundle', function () {}, {
  create: function create() {
    return Oskari.clazz.create('Oskari.file-upload.BundleInstance');
  },
  start: function start() {},
  stop: function stop() {}
}, {
  source: {
    scripts: [{
      type: 'text/javascript',
      src: './instance.js'
    }],
    locales: [{
      lang: 'fi',
      type: 'text/javascript',
      src: './resources/locale/fi.js'
    }]
  }
});
Oskari.bundle_manager.installBundleClass('file-upload', 'Oskari.file-upload.Bundle');
import './instance.js'